/**
 * Created by Aleksandr on 17.04.2024
 */

const PictureComponent = cc.Node.extend({
    ctor: function (level) {
        this._super();

        this.effect = "victory.window.bonus_animation";
        let animationName = "bonus_animation_json";
        if (level.isHard()) {
            animationName = "hard_animation_json";
            this.effect = "victory.window.hard_animation";
        }
        this.content = new cleverapps.Spine(bundles.victory_window.jsons[animationName]);
        this.content.setAlignment(cleverapps.styles.PictureComponent);
        this.addChild(this.content);

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(this.content.getContentSize());
    },

    showUp: function () {
        this.setOpacity(0);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            cleverapps.effects.fireAction(this.effect),
            new cc.CallFunc(() => {
                if (this.content.setAnimation) {
                    this.content.setAnimationAndIdleAfter("showUp", "idle");
                }
            })
        ));
    }
});

cleverapps.styles.PictureComponent = {
    x: { align: "center" },
    y: { align: "center" }
};